export enum FOLIOS_MODE {
    INTEGRATED = 'integrated',
    SUBMITTED = 'submitted',
}

export type TViolation = {
    code: string;
    message: string;
};

export type TBuyerAddress = {
    city: string;
    line0: string;
    line1: string;
    line2: string;
    state: string;
    postal: string;
    country: string;
};

export type TBuyerRegistrationNo = {
    id: string;
    type: string;
};

export type TLineItem = {
    Group: string;
    TrxNo: number;
    Product: string;
    TrxCode: string;
    TrxDate: string;
    TrxType: string;
    taxRate: string;
    Currency: string;
    Quantity: number;
    SubGroup: string;
    subtotal: number;
    CashierId: string;
    NetAmount: number;
    Reference: string;
    UnitPrice: number;
    taxAmount: number;
    Description: string;
    FinDmlSeqNo: number;
    GrossAmount: number;
    TrxDateTime: string;
    ExchangeRate: number;
    TranActionId: number;
    OrgResvNameId: string;
    ArrangementCode: string;
    totalExcludeTax: number;
    LocalTrxDateTime: string;
    GuestAccountDebit: number;
    classification: string;
};

export type TInvoice = {
    id: string;
    tenant_id: string;
    scenario: string;
    buyer_name: string;
    buyer_tin: string;
    buyer_registration_no?: TBuyerRegistrationNo;
    buyer_sst_reg_no: string;
    buyer_email: string;
    buyer_address?: TBuyerAddress;
    buyer_phone: string;
    invoice_no: string;
    invoice_type: string;
    currency_code: string;
    total_exclude_tax: number;
    total_include_tax: number;
    total_payable: number;
    total_tax: number;
    total_tax_per_tax_type: number;
    tax_type: string;
    original_ref: string;
    submit_yn: boolean;
    status: string;
    submit_datetime: string;
    created_on: string;
    updated_on: string;
    line_items?: TLineItem[];

    count_line_items?: number;
};

export type TSupplier = {
    name: string;
    tin: string;
    registrationNo?: TBuyerRegistrationNo;
    SSTregistrationNo: string;
    tourismTaxNo: string;
    email: string;
    msic: string;
    description: string;
    address: TBuyerAddress;
    phone: string;
};

export enum InvoiceStatus {
    PENDING = 'PENDING',
    SUBMITTED = 'SUBMITTED',
    FAILED = 'FAILED',
}

export const InvoiceStatusMapping = {
    [InvoiceStatus.PENDING]: 'Pending',
    [InvoiceStatus.SUBMITTED]: 'Submitted',
    [InvoiceStatus.FAILED]: 'Failed',
};

export const InvoiceStatusColorMapping = {
    [InvoiceStatus.PENDING]: 'orange',
    [InvoiceStatus.SUBMITTED]: 'green',
    [InvoiceStatus.FAILED]: 'red',
};
